export const FETCH_USER_DATA = "FETCH_USER_DATA";
export const RESET_USER_DATA = "RESET_USER_DATA";
